import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Users } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { Observable } from 'rxjs';

export class LoggedInUserDetailsEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  httpClient = inject(HttpClient);

  get(): Observable<Users.User> {
    return this.httpClient.get<Users.User>(`${this.env.constants.API_URL}/users/me/details`)
  }
}
